import IconBugReport from '@material-ui/icons/BugReport';
import { styled } from '@material-ui/styles';
import React from 'react';

import { DebugColorContants } from './DebugControl';
import { DebugDialog } from './DebugDialog';
import { GestureEvent } from 'Events/withEvent';
import { useIsModeDebug } from './DebugContext';

export type DebugButtonProps = {
    title?: React.ReactNode;
    data?: any;
    style?: React.CSSProperties;
    collapsed?: number | boolean;
    children?: React.ReactNode;
};

export const DebugButton: React.FC<DebugButtonProps> = ({ title, data, style, collapsed, children }) => {
    const isDebug = useIsModeDebug();

    const [visible, setVisible] = React.useState<boolean>(false);
    const hide = () => setVisible(false);
    const show = (e?: GestureEvent) => {
        e?.stopPropagation();
        setVisible(true);
    };
    return !isDebug ? null : (
        <Container role="DebugButton" style={style}>
            <IconBugReport
                onClick={show}
                style={{ width: 18, height: 18, padding: 1, color: DebugColorContants.COLOR }}
            />
            {visible && (
                <DebugDialog title={title} data={data} collapsed={collapsed} onClose={hide}>
                    {children}
                </DebugDialog>
            )}
        </Container>
    );
};

const Container = styled('div')({
    position: 'absolute',
    top: 12,
    right: 12,
    cursor: 'pointer',
    background: DebugColorContants.BACKGROUND,
    width: 18,
    height: 18,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 9,
    boxShadow: '0 10px 25px -5px rgb(44 179 240 / 60%)',
    zIndex: 12,
});
